/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ObservableDoubleComponent from "../Utility/Component/Observable/ObservableDoubleComponent";

@cc._decorator.ccclass()
export default class DtModObservable extends ObservableDoubleComponent
{
    protected value: number = 1;

    public Multiply(value: number): number
    {
        return this.value * value;
    }

    public Reduce(value: number): number
    {
        return this.value > 0 ? value / this.value  : this.value;
    }

    public Reset(): this
    {
        this.value = 1;
        return this;
    }
}
